const navLinks = [
  {
    name: 'Accueil',
    link: '/',
  },
  {
    name: 'À propos de nous',
    link: 'about',
  },
  {
    name: 'Réalisations',
    link: 'portfolio',
  },
  {
    name: 'Historique',
    link: 'historique',
  },
  {
    name: 'Contact',
    link: 'contact',
  },
];

export default navLinks;
